export const COLORS = {
  cases: ['#CC0000', '#F4D2D2'],
  deaths: ['#1D204E', '#CCCEE5'],
  tests: ['#009999', '#CBECEC'],
};
